import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const stickyClasses = 'sticky top-0';
const notStickyClasses = 'relative';

const NavBar = ({
  className,
  children,
  isSticky,
  WhiteLabeling,
}: {
  className?: string;
  children?: React.ReactNode;
  isSticky?: boolean;
  WhiteLabeling?: {
    topBarBackground?: string;
  };
}) => {
  const style = WhiteLabeling?.topBarBackground
    ? { backgroundColor: WhiteLabeling.topBarBackground }
    : undefined;

  return (
    <div
      style={style}
      className={classnames(
        'bg-secondary-dark z-20 border-black px-1',
        isSticky && stickyClasses,
        !isSticky && notStickyClasses,
        className
      )}
    >
      {children}
    </div>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isSticky: PropTypes.bool,
  WhiteLabeling: PropTypes.object,
};

export default NavBar;
